module.exports = __webpack_public_path__ + "media/images/attachment-placeholder-016c4749b3058cab422bc213d62f829a.jpg";